{
    "routes": {
        "home": "Создай аудиокнигу при помощи искусственного интеллекта | Зарабатывай на аудиокниге уже сейчас — Speechki",
        "login": "Вход",
        "profile": "Профиль автора",
        "contract": "Договор на публикацию аудиокниги",
        "upload": "Загрузить книгу",
        "publish": "Публикация аудиокниги",
        "editor": "{title} — Редактор Speechki",
        "contacts": "Контакты",
        "unavailable": "На сайте проводятся технические работы",
        "contracted": "Заказные книги",
        "podcasts": "Подкасты"
    },
    "support": {
        "tooltip": "Написать в службу поддержки. Мы отвечаем пн-пт с 6:00 по 17:00 (GMT 3).",
        "answer": "Мы отвечаем пн-пт с 6:00 по 17:00 (GMT 3).",
        "ideabutton": "Есть идея?",
        "ideasend": "Отправьте нам свою идею",
        "send": "Написать в службу поддержки",
        "label": "Сообщение",
        "placeholder": "Введите сообщение",
        "success": "Мы получили ваше обращение. Ответ поступит на почту, указанную в вашем аккаунте.",
        "email": "Email для связи:",
        "faq": "Найдите ответ на ваш вопрос в FAQ"
    },
    "booksList": {
        "title": "Мои книги",
        "upload": "Загрузить книгу",
        "searchPlaceholder": "Введите название, автора или ISBN",
        "publishDate": "Дата публикации",
        "unpublished": "Не опубликована",
        "narrator": "Читает",
        "size": "Объем",
        "authorUnknown": "Автор неизвестен",
        "editTooltip": "Редактировать данные книги",
        "nobooks": "У вас ещё нет книг. Создайте свою первую аудиокнигу в Speechki!",
        "tutorial": "Инструкция по созданию книги",
        "notfound": "Не найдено книг",
        "noCategory": "Не указана",
        "faq": "Перейти в FAQ (часто задаваемые вопросы)"
    },
    "deleteBook": {
        "title": "Удалить книгу?",
        "text": "Книга «{name}» будет удалена. Её восстановление будет невозможно. Все равно удалить?",
        "delete": "Удалить"
    },
    "confirmModal": {
        "ok": "Применить",
        "cancel": "Отменить"
    },
    "editor": {
        "goToSettings": "Перейти к настройкам книги",
        "contents": {
            "title": "Оглавление",
            "chapters": "Главы",
            "toggleChapters": "Показать/скрыть главы",
            "notice": "Добавьте разметку глав в редакторе, чтобы увидеть содержание вашей книги.",
            "step1": "Выберите предложение",
            "step2": "Нажмите кнопку настроек",
            "step3": "Выберите тип \"Глава\"",
            "step4": "Отлично! Всё готово.",
            "sectionDuration": {
                "ok": "Размер файла для этой главы не превысит максимальный (4гб). <br> Размер: {size}гб <br> Длительность: {duration}",
                "notOk": "Размер файла для этой главы превысит максимальный. <br> Размер: {size}гб <br> Длительность: {duration}мин <br> Необходимо разделить главу на несколько.",
                "firstChapterError": "Размер файла для текста между заголовком и первой главной превысит масимальный (4гб). <br> Необходимо разделить главу на несколько.",
                "beforeChapter": "Текст до глав"
            }
        },
        "text": {
            "prev": "Предыдущая часть",
            "next": "Следующая часть",
            "pagination": "Страница {n} из {size}",
            "gotopage1": "Перейти на",
            "gotopage2": "страницу",
            "gotopagego": "Перейти",
            "tipLeftClick": "ЛЕВЫЙ КЛИК - открыть предложение в редакторе",
            "tipRightClick": "ПРАВЫЙ КЛИК - открыть настройки предложения",
            "pageLabel": "Страница",
            "pageOf": "из {total}",
            "pageInput": "Номер страницы",
            "matchCount": "нет совпадений | {n} совпадение | {n} совпадения | {n} совпадений",
            "matchPosition": "{current} из {total}",
            "noMatches": "Нет совпадений",
            "matchListTitle": "{count} по запросу «{query}»",
            "matchListHint": "Нажмите, чтобы перейти к совпадению",
            "matchLocation": "Стр. {page} · Предложение {sentence}",
            "matchLocationPage": "Стр. {page}",
            "showAllMatches": "Показать все совпадения",
            "seeAllComments": "Все комментарии",
            "prevMatch": "Предыдущее совпадение",
            "nextMatch": "Следующее совпадение",
            "prevPage": "Предыдущая страница",
            "nextPage": "Следующая страница"
        },
        "toolbar": {
            "audioGenarating": "Предложение генерируется",
            "commonSettings": "Общая настройка предложения",
            "weRecommend": "Рекомендуем",
            "noVoices": "Нет доступных голосов",
            "pickVoice": "Необходимо выбрать голос",
            "backButton": "Назад к настройкам предложения",
            "wordSettings": "Настройка выделенного слова",
            "save": "Сохранить изменения",
            "cancel": "Не применять",
            "switchPlayer": "Новый плеер",
            "copyLink": "Копировать ссылку",
            "copyText": "Копировать текст",
            "copyLinkSuccess": "Ссылка скопирована",
            "copyTextSuccess": "Текст скопирован",
            "isSample": "Сэмпл",
            "suggestion": "Предсказание",
            "dictionary": "Словарь фраз",
            "specialSymbols": "Спецсимволы",
            "phonemes": "Фонемы",
            "emotion": "Эмоция"
        },
        "ssml": {
            "modes": {
                "visual": "Визуальный редактор",
                "source": "Редактировать"
            },
            "phoneme": {
                "label": "Фонема слова",
                "placeholder": "Выберите фонему",
                "enter": "+ Ввести вручную",
                "title": "Ввод фонемы вручную",
                "inputPlaceholder": {
                    "syllable": "Введите звук",
                    "word": "Введите слово"
                }
            },
            "sub": "Заменить на",
            "say-as": "Произносить как",
            "emphasis": "Акцент",
            "stress": "Ударение",
            "prosody": {
                "pitch": "Питч",
                "volume": "Громкость",
                "rate": "Скорость"
            },
            "mstts:express-as": {
                "style": "Стиль",
                "styledegree": "Уровень"
            },
            "tip": "Используйте Ctrl или Shift, чтобы выбрать несколько слов",
            "selectAll": "Выбрать все"
        },
        "postproduction": "Постобработка",
        "crmOrderState": {
            "text": "<b>{destination}</b>?",
            "cancel": "Отменить",
            "success": "Готово!",
            "successText": "Статус заказа изменен",
            "error": "Изменение заказа",
            "errorText": "Повторите операцию ещё раз",
            "orderCompleted": "Заказ завершен",
            "orderCompletedMessage": "Заказ завершен. Вы больше не можете редактировать эту книгу"
        },
        "glueSentences": {
            "title": "Объединить предложения",
            "notice": "Объединить предложения?",
            "newSentence": "Итоговый результат:",
            "merge": "Объединить",
            "state": {
                "merging": "Объединяем предложения..",
                "generating": "Переозвучиваем предложения.."
            }
        },
        "suggestion": {
            "title": "Предсказание",
            "noData": "Нет предсказаний",
            "isCompleted": "Завершено",
            "errorFound": "Найдена ошибка",
            "filter": {
                "all": "Все",
                "isCompleted": "Завершенные",
                "unCompleted": "Незавершенные"
            },
            "childs": {
                "highlight": "Выделить предсказания",
                "goto": "Перейти к предсказаниям"
            }
        },
        "brokenParts": {
            "menuItem": "Сломанные предложения",
            "noData": "Нет сломанных предожений. Кажется, все в порядке!"
        },
        "shuffle": {
            "title": "Случайные предложения",
            "menuItem": "Случайные предложения",
            "noData": "Пока никаких предложений нет"
        },
        "dictionary": {
            "title": "Словарь фраз",
            "form": {
                "sourceLabel": "Исходный текст",
                "sourcePlaceholder": "Введите фразу",
                "replaceLabel": "Замена",
                "replacePlaceholder": "Введите замену",
                "providerLabel": "Провайдер"
            }
        },
        "specialSymbols": {
            "title": "Спецсимволы",
            "form": {
                "sourceLabel": "Исходный символ",
                "sourcePlaceholder": "Введите символ",
                "replaceLabel": "Замена",
                "replacePlaceholder": "Введите замену",
                "providerLabel": "Провайдер"
            }
        },
        "phonemes": {
            "title": "Фонемы",
            "form": {
                "title": "Создание фонемы",
                "keyLabel": "Слово",
                "keyPlaceholder": "Введите cлово",
                "valueLabel": "Фонема",
                "valuePlaceholder": "Введите фонему"
            }
        }
    },
    "textsearch": {
        "placeholder": "Поиск по тексту",
        "showAll": "Показать все результаты"
    },
    "textEntityControl": {
        "delete": "Удалить предложение",
        "play": "Воспроизвести отсюда",
        "textType": "Тип текста",
        "addCorrection": "Редактировать",
        "leaveComment": "Оставить комментарий"
    },
    "pause": {
        "pause": "Пауза",
        "duration": "Продолжительность (мс)",
        "applyToAll": "Применить ко всем",
        "pauses": "паузам между предложениями",
        "paragraphEnds": "окончаниям параграфов",
        "bumpTitle": "Вставить отбивку",
        "settingsTitle": "Настройки паузы",
        "bump": {
            "remove": "Убрать отбивку",
            "audio": "Аудио",
            "placeholder": "Выберите отбивку",
            "empty": "Нет отбивок"
        },
        "pause_configs": {
            "title": "Настройки паузы"
        }
    },
    "misc": {
        "send": "Отправить",
        "profile": "Профиль",
        "logout": "Выйти",
        "settings": "Настройки",
        "download": "Скачать",
        "editor": "Редактор",
        "delete": "Удалить",
        "language": "Язык",
        "category": "Категория",
        "size": "Объем",
        "publish": "Опубликовать",
        "lastChange": "Последнее изменение",
        "trialVersion": "Триал-версия",
        "save": "Сохранить",
        "type": "Тип",
        "speed": "Скорость",
        "volume": "Громкость",
        "voice": "Голос",
        "effect": "Эффект",
        "select": "Выбрать",
        "word": "Слово",
        "phoneme": "Фонема",
        "loadmore": "Загрузить ещё",
        "notfound": "Не найдено",
        "example": "Пример",
        "enterText": "Введите текст",
        "author": "Автор",
        "back": "Назад",
        "lastName": "Фамилия",
        "firstName": "Имя",
        "patronymic": "Отчество",
        "dateOfBirth": "Дата рождения",
        "phoneNumber": "Номер телефона",
        "pseudonym": "Псевдоним",
        "pseudonymes": "Псевдонимы",
        "description": "Описание",
        "loading": "Загрузка",
        "toBookList": "К списку книг",
        "apply": "Применить",
        "edit": "Изменить",
        "status": "Статус",
        "sentence": "Предложение",
        "error": "Ошибка",
        "add": "Добавить",
        "date": "Дата",
        "cancel": "Отменить",
        "confirm": "Подтвердить",
        "close": "Закрыть",
        "token": "Токен",
        "done": "Готово",
        "search": "Поиск",
        "anonimous": "Аноним",
        "selectAll": "Выбрать всё",
        "unselectAll": "Очистить",
        "continue": "Продолжить",
        "reply": "Ответить",
        "refresh": "Обновить"
    },
    "trialNotice": {
        "popupContent": "<h4>Прослушайте отрывок из вашей книги!</h4><ol><li>Нажмите на кнопку «Скачать аудиокнигу»</li><li>В открывшемся окне нажмите «Запустить сборку аудиокниги»</li><li>Дождитесь сборки аудиофайла</li><li>Прослушайте аудио или скачайте его бесплатно</li></ol>",
        "okay": "Понятно",
        "youUseFree": "Вы пользуетесь бесплатной версией редактора аудиокниги.",
        "text": "Озвучено только <b>10 первых предложений.</b> Для озвучивания всей книги приобретите платный тариф стоимостью {price} {currency} за каждую 1000 символов вашего произведения.",
        "voice": "Озвучить"
    },
    "export": {
        "title": "Скачать аудиокнигу",
        "downloadAudiobook": "Скачать аудиокнигу",
        "trial": "Вы экспортируете триальную версию книги. <br /> Будут озвучены только первые 10 предложений.",
        "buildNew": "Собрать новую",
        "runBuild": "Запустить сборку книги",
        "types": {
            "metaStorytel": "Скачать мета Storytel",
            "metaBookmate": "Скачать мета Bookmate",
            "storytelArchive": "Архив Storytel",
            "bookmateArchive": "Архив Bookmate",
            "download": "Скачать"
        },
        "playerNotice": "Сгенерируйте книгу одним файлом, чтобы прослушать её.",
        "notice": "Вы можете скачать вашу аудиокнигу и начать её распространение самостоятельно прямо сейчас!",
        "repair": {
            "title": "Обнаружены предложения без аудио!",
            "forExample": "Например",
            "total": "Всего: 0 шт. | Всего {n} шт. |  Всего {n} шт. | Всего {n} шт. |",
            "notice": "Если экспортировать книгу сейчас, часть предложений не будет озвучено. Хотите продолжить?",
            "export": "Экспортировать",
            "openInEditor": "Открыть в редакторе",
            "backToBookEditing": "Вернуться к книге"
        },
        "status": {
            "actual": "Актуальная сборка",
            "old": "Устаревшая сборка",
            "missing": "Нет сборки",
            "progress": "Процесс сборки",
            "check": "Проверяем готовность книги к экспорту",
            "repair": "Подготавливаемся к экспорту",
            "build": "Идет сборка...",
            "brokenParts": "Пустые аудио в книге"
        },
        "singleFileLoader": "Создание аудиокниги занимает около 5 минут.",
        "archiveLoader": "Создание книги длительностью 4 часа занимает 20 минут",
        "pleaseWait": "Пожалуйста подождите. Идет обработка книги",
        "ready": "Аудиокнига готова",
        "type": "Формат",
        "bookNotActual": "Вы изменили книгу, версия, которую вы слушаете в этом плеере более не актуальна",
        "authorOptions": {
            "excludeAuthor": "Без имени автора",
            "excludeTitle": "Без заголовка",
            "excludeAuthorAndTitle": "Без имени автора и заголовка",
            "fullText": "Весь текст"
        }
    },
    "bookEdit": {
        "title": "Редактировать книгу",
        "bookTitle": "Название",
        "saveTitleTooltip": "Сохранить название",
        "editTitleTooltip": "Редактировать название",
        "originalTitle": "Название на оригинальном языке",
        "ageRating": {
            "type": "Стандарт возрастного рейтинга",
            "label": "Возрастной рейтинг"
        },
        "cover": "Обложка",
        "generate": "Сгенерировать",
        "coverReqs": "Требования к обложке:<b>формат JPEG, размер 640x640</b>.",
        "playerLabel": "Ваша аудиокнига",
        "category": {
            "add": "+ Добавить категорию",
            "empty": "Необходимо указать хотя бы одну категорию.",
            "modalTitle": "Выберите жанры"
        },
        "translator": "Переводчик",
        "translatorPlaceholder": "Имя переводчика",
        "description": "Описание книги",
        "descriptionPlaceholder": "Введите описание книги",
        "save": "Сохранить изменения",
        "size": " тыс. символов",
        "document": "Скачать текст книги"
    },
    "personages": {
        "select": {
            "placeholder": "Поменять роль"
        },
        "manager": {
            "trigger": "Редактировать роли",
            "title": "Управление ролями",
            "add": "Добавить роль"
        },
        "delete": {
            "title": "Удаление роли"
        },
        "list": {
            "name": "Роль",
            "namePlaceholder": "Название роли",
            "speaker": "Голос"
        }
    },
    "upload": {
        "title": "Загрузить книгу",
        "format": "(только формат docx)",
        "fileLabel": "Нажмите, чтобы загрузить файл DOCX",
        "rules": "Правила подготовки книги к загрузке в сервис",
        "name": "Название",
        "upload": "Загрузить",
        "selectLanguage": "Выберите язык",
        "noAuthors": "Нет авторов",
        "authorData": "Данные автора",
        "rightsNotice": "Эти данные необходимы, чтобы защитить ваши права.",
        "lastNamePlaceholder": "Грушев",
        "firstNamePlaceholder": "Василий",
        "patronymicPlaceholder": "Евгеньевич",
        "willPublish": "Я планирую продавать аудиокнигу в магазинах",
        "pseudonymNotice": "Я пишу под своим именем",
        "tariffs": "Голос доступен в выделенных пакетах",
        "freeTariff": "Не для публикации и продаж",
        "notice": "Озвучка полной книги выбранным голосом рассчитывается по тарифу, в который входит голос.",
        "tariffPrice": "{price} {currency}/1000 симв.",
        "iHaveIsbn": "У меня есть ISBN",
        "titlePlaceholder": "Война и мир",
        "stayConfidential": "Не заполнять информацию",
        "fillProfile": "Заполнить данные автора",
        "stayConfidentialNotice": "Вы предпочли не заполнять информацию",
        "addPseudo": "+ Добавить псевдоним",
        "copyrightHolder": "Правообладатель",
        "speed": "Скорость чтения"
    },
    "profile": {
        "title": "Редактирование профиля",
        "emptyData": "Заполните обязательные поля для продолжения работы с сервисом. Это требуется дляподтверждения вашей личности и защиты ваших авторских прав.<br />Обязательные поля отмечены знаком *.",
        "personalData": "Личные данные",
        "contactData": "Контактные данные",
        "address": "Адрес регистрации",
        "postalAddress": "Почтовый адрес",
        "otherData": "Прочая информация",
        "site": "Сайт",
        "aboutme": "Обо мне",
        "iAgreeWith": "Я согласен с",
        "termsOfService": "пользовательским соглашением",
        "security": "Безопасность",
        "changePassword": "Изменить пароль",
        "newPass": "Новый пароль",
        "confirmPass": "Повторите пароль"
    },
    "payment": {
        "title": "Покупка",
        "type": "Услуга",
        "voicing": "Озвучивание книги",
        "promocode": "Промокод",
        "symbols": " сивмолов",
        "pay": "Оплатить",
        "total": "Итого",
        "thanks": "Спасибо за покупку!",
        "successNoLimit": "Если вы успешно оплатили озвучивание одной книги, озвучивание книги запустится автоматически сразу после поступления оплаты на наш счет.<br />Обычно это занимает от 1 минуты до 1 часа.",
        "haveQuestions": "Есть вопросы? Пишите",
        "successPayment": "Оплата успешно проведена",
        "thankYou": "Спасибо за использование нашего сервиса. Ваша книга озвучивается роботом.",
        "useEditor": "Процесс озвучивания не мешает работе с редактором аудиокниги —продолжайте работу!<br />Как только процесс завершится — вы сможете экспортировать вашуаудиокнигу одним файлом или с разбивкой по главам согласноОглавлению в левой части экрана редактора.",
        "redirect": "Сейчас вы будете перенаправлены на страницу оплаты",
        "packages": "Пакет голосов",
        "ok": "Понятно",
        "perhour": "/ час записанной аудиокниги",
        "plans": {
            "title": "Тарифы и цены"
        },
        "help": {
            "common": "Внимание! Изменение голоса после оплаты доступно только для каждого отдельного предложения.",
            "noStress": "Внимание! Этот голос не позволяет управлять ударениями.",
            "priceSymbolsNotice": "Стоимость рассчитана исходя из объёма вашей книги и стоимости за 1000 символов."
        }
    },
    "login": {
        "signIn": "Войти в свой аккаунт",
        "signUp": "Регистрация",
        "email": "Ваш Email",
        "password": "Ваш пароль",
        "showPass": "Показать пароль",
        "confirmPass": "Повторите пароль",
        "haveAnAccount": "Есть аккаунт? Войти на сайт",
        "agreement": "Регистрируясь, я принимаю условия",
        "terms": "пользовательского соглашения",
        "reset": {
            "trigger": "Забыли пароль?",
            "title": "Восстановление пароля",
            "request": "Отправить",
            "linkSent": "Мы отправили вам ссылку на восстановление пароля. Проверьте email {email}.",
            "submit": "Сохранить пароль",
            "password2": "Повторите пароль"
        }
    },
    "contract": {
        "title": "Договор на публикацию аудиокниг",
        "current": "Текущий договор",
        "fulltext": "Текст договора",
        "status": "Статус",
        "statuses": {
            "actual": "Подписан (актуальная версия)",
            "old": "Подписан (старая версия)",
            "draft": "Черновик",
            "moderate": "Ждет одобрения администрации",
            "expired": "Устарел",
            "canceled": "Отменен"
        },
        "dateCreated": "Дата создания",
        "dateEnd": "Дата окончания",
        "autoRenewal": "Автопродление",
        "off": "Отключено",
        "on": "Включено",
        "turnOff": "Отключить",
        "stopRenewalNotice": "Автопродление договора на публикацию будет остановлено",
        "newVersionAvailable": "Доступна новая версия",
        "signNewVersion": "Подписать новую версию",
        "newVersion": "Новая версия договора",
        "comments": "Комментарии по модерации",
        "sign": "Подписать",
        "citizenship": "Гражданство",
        "confirm": "Подтвердить данные",
        "editData": "Изменить данные",
        "checkData": "Проверьте личные данные",
        "verifyData": "Подтвердите личность"
    },
    "massReplacement": {
        "trigger": "Найти и заменить во всем тексте",
        "title": "Найти и заменить",
        "target": "Найти: ",
        "replacement": "Заменить на: ",
        "position": "{n} из {total}",
        "diffSwitch": "Показывать результат замены",
        "buttons": {
            "replace": "Заменить",
            "replaceAll": "Заменить всё",
            "previous": "Назад",
            "next": "Далее",
            "fullList": "Показать все"
        },
        "success": "Измененные предложения были переозвучены",
        "generation": "Генерация предложений: {n}/{total}"
    },
    "bookPartsChanges": {
        "menuItem": "История изменений",
        "title": "История изменений",
        "backToBookEditing": "Вернуться к книге",
        "results": {
            "initText": "Первоначальный текст",
            "currentText": "Текущий текст",
            "noData": "Пока изменений нет"
        }
    },
    "symbolsRemainder": {
        "forAdjustments": "Для корректировок",
        "generationTooltip": "Каждая новая перегенерация предложения списывает из этого объема количество символов предложения",
        "unlimited": "У вас безлимитный тариф на корректировки",
        "youHave": "У вас",
        "forAjustmentsEnd": "на корректировки",
        "and": "и",
        "limitReached": "Вы исчерпали лимит на корректировки, установленный системой",
        "support": "Обратитесь в поддержку, мы решим этот вопрос в индивидуальном порядке.",
        "inTouch": "Мы на связи!"
    },
    "pseudonymPicker": {
        "add": "+ Добавить псевдоним",
        "title": "Новый псевдоним",
        "edit": "Редактировать псевдоним",
        "description": "Описание"
    },
    "errors": {
        "generationError": "Произошла ошибка при генерации"
    },
    "docsDropdown": {
        "tutorial": "Инструкция",
        "terms": "Пользовательское соглашение",
        "rules": "Правила",
        "payment": "Оплата и возврат",
        "prepareBook": "Подготовка книги к загрузке",
        "contracts": "Договоры на публикацию аудиокниг"
    },
    "bookReload": {
        "title": "Обновить файл книги",
        "notice": "Мы удалим весь текст книги и загрузим её заново из файла.",
        "button": "Загрузить"
    },
    "currency": {
        "currency": "Валюта"
    },
    "adminBookControls": {
        "title": "Управление книгой",
        "addContractor": "Добавить контрагента",
        "noContractors": "Нет контрагентов",
        "book": "Книга",
        "contractor": "Контрагент",
        "contractors": "Контрагенты",
        "published": "Опубликована",
        "notPublished": "Не опубликована",
        "sendFtp": "Отправить книгу",
        "sendMeta": "Отправить мета",
        "status": "Статус",
        "ftpSuccess": "Книга отправлена",
        "metaSuccess": "Мета-данные отправлены",
        "success": "Успешно",
        "errorFtp": "Ошибка отправки",
        "buildType": "Тип сборки"
    },
    "tutorial": {
        "next": "Далее",
        "prev": "Назад",
        "finish": "Готово",
        "skip": "Пропустить",
        "of": "из"
    },
    "dateRange": {
        "dateStart": "Дата начала",
        "endDate": "Дата окончания",
        "clear": "Очистить",
        "apply": "Применить"
    },
    "partsPlayer": {
        "length": "Страница {page}/{total} предложение {cur}/{size}",
        "lengthReviewer": "Страница {page}/{total} · Предложение {cur}/{size}",
        "pause": "Пауза:",
        "sec": "сек",
        "bump": "Аудио отбивка",
        "try": "Попробовать новый плеер",
        "old": "Старый плеер",
        "loadingPage": "Загружаем страницу {number}",
        "playing": "Воспроизведение",
        "paused": "Пауза",
        "play": "Воспроизвести",
        "pauseAction": "Пауза",
        "prevSentence": "Предыдущее предложение",
        "nextSentence": "Следующее предложение"
    },
    "sentenceSplitter": {
        "splitOn2": "Разделить предложение на 2",
        "splitSentence": "Разделить предложение",
        "split": "Разделить",
        "selectPoint": "Выберите точку для разделения предложения",
        "oneWord": "Предложение состоит из одного слова, невозможно его разделить.",
        "warning": "Все настройки предложения, если вы их делали, придется внести заново, в том числе паузы, ударения и фонемы.",
        "loading": "Делим предложение"
    },
    "textPagination": {
        "paymentNotice": "Переход между страницами станет доступным после оплаты озвучивания.",
        "goTo": "Перейти на"
    },
    "corrections": {
        "title": "Правки",
        "add": {
            "title": "Добавить правку",
            "comment": "Комментарий",
            "commentPlaceholder": "Введите комментарий",
            "parent": "Родительская правка",
            "empty": "Нет правок",
            "save": "Сохранить",
            "cancel": "Отменить",
            "success": "Правка успешно добавлена"
        },
        "list": {
            "empty": "Нет правок",
            "reviewerEmptyTitle": "Нет правок",
            "reviewerEmptyHint": "Наведите курсор на любое предложение в аудиокниге и выберите «Оставить комментарий», чтобы запросить изменение.",
            "backToBookEditing": "Вернуться к книге"
        },
        "item": {
            "title": "Правка №",
            "saved": "Правка сохранена",
            "statusError": "Ошибка при изменении статуса",
            "tryAgain": "Пожалуйста, попробуйте позже",
            "createChild": "Создать дочернюю правку",
            "viewInBook": "Открыть в книге",
            "addComment": "Добавить комментарий",
            "writeYourComment": "Напишите комментарий…"
        },
        "report": {
            "get": "Скачать отчет",
            "error": "Ошибка при генерации отчета"
        },
        "player": {
            "play": "Воспроизвести",
            "pause": "Пауза",
            "mute": "Выключить звук",
            "unmute": "Включить звук",
            "progress": "Прогресс воспроизведения"
        },
        "delete": {
            "trigger": "Удалить эту правку",
            "title": "Удалить правку",
            "warning": "Если у этой правки есть <b>дочерние правки</b>, они будут удалены!",
            "content": "Вы хотите удалить правку"
        }
    },
    "notes": {
        "add": {
            "title": "Добавить заметку",
            "commentPlaceholder": "Введите текст заметки",
            "empty": "Нет правок",
            "save": "Сохранить",
            "cancel": "Отменить",
            "success": "Заметка успешно добавлена"
        },
        "item": {
            "title": "Правка заметки",
            "success": "Заметка успешно сохранена"
        },
        "list": {
            "empty": "Нет заметок"
        },
        "delete": {
            "trigger": "Удалить заметку",
            "title": "Удаление заметки",
            "content": "Вы хотите удалить эту заметку?",
            "warning": "Заметка будет удалена"
        },
        "build": {
            "label": "Экспорт заметок:",
            "download": "Скачать заметки",
            "create": "Обновить сборку",
            "error": "Ошибка при сборке",
            "time": "сборка завершена в ",
            "status": {
                "building": "Обновление сборки..."
            }
        },
        "subtitles": {
            "label": "Субтитры:",
            "download": "Скачать"
        },
        "router": {
            "text": "Все заметки"
        }
    },
    "podcasts": {
        "title": "Подкасты",
        "create": "Создать",
        "delete": {
            "title": "Удаить подкаст",
            "text": "Вы точно хотите удалить подкаст "
        },
        "card": {
            "explicit": "18+"
        },
        "detail": {
            "editPodcast": "Редактировать",
            "cancelEditing": "Отменить",
            "name": "Название подкаста",
            "rss": "RSS-лента подкаста",
            "email": "Контактный email",
            "author": "Автор",
            "descr": "Описание",
            "lang": "Язык",
            "category": "Категория",
            "isExplicit": "18+",
            "isActive": "Активировать",
            "save": "Сохранить",
            "delete": "Удалить этот подкаст",
            "episodes": "Эпизоды",
            "editEpisodes": "Управление эпизодами",
            "created1": "Подкаст создан! теперь вы можете ",
            "created2": " для вашего подкаста",
            "addLink": "создать эпизоды",
            "success": "Подкаст создан!"
        },
        "list": {
            "empty": "Пока нет подкастов",
            "createOne": "Создать"
        },
        "copyFeed": "Скопировать RSS",
        "copyFeedSuccess": "Ссылка на RSS-ленту скопирована",
        "episodes": {
            "empty": "Пока нет эпизодов.",
            "addEpisode": "+ Добавить эпизод",
            "notSelected": "Вы не выбрали эпизод",
            "detail": "Управление эпизодом",
            "type": "Тип",
            "typeNotice": "Какую сборку книги нужно включить в RSS-ленту подкаста: полную книгу, только сэмплы или обе",
            "builds": "Статус сборок книги",
            "hasBuild": "OK! Сборка существует",
            "nobuild": "Нет сборки! Пожалуйста соберите книгу в нужном формате",
            "buildsNotice": "Проверка на доступность нужных сборок книги",
            "delete": "Удалить эпизод",
            "book": "Книга",
            "searchBook": "Название книги"
        },
        "category": {
            "trigger": "Изменить категорию"
        }
    },
    "samples": {
        "title": "Семплы книги",
        "clearSamples": "Очистить семпл",
        "noSamples": "Нет предложений. Вы можете отменить предложение как семпл в редакторе",
        "confirm": "Удалить все предложения из семпла книги?",
        "clear": "Очистить"
    },
    "crm": {
        "customers": {
            "title": "Клиенты",
            "list": {
                "empty": "Пока нет клиентов",
                "notFound": "Клиенты не найдены"
            }
        },
        "orders": {
            "title": "Заказы",
            "list": {
                "title": "Название",
                "author": "Автор",
                "voice": "Голос",
                "lastChange": "Посл. изменение",
                "customer": "Клиент",
                "type": "Тип",
                "state": "Статус",
                "empty": "Нет заказов",
                "notFound": "Не найдено заказов",
                "create": "Создать заказ"
            },
            "export": {
                "button": "Экспорт CSV",
                "error": "Не удалось выгрузить заказы",
                "tryAgain": "Попробуйте ещё раз позже"
            },
            "backButton": "Вернуться к заказу",
            "selectLanguage": "Пожалуйста, сначала выберите язык",
            "selectCustomer": "Пожалуйста, сначала выберите клиента",
            "selectOrder": "Пожалуйста, выберите заказ",
            "noSpeakers": "Спикеры не найдены"
        },
        "users": {
            "list": {
                "empty": "Пока нет пользователей",
                "notFound": "Пользователи не найдены"
            }
        },
        "tokens": {
            "title": "Токены",
            "list": {
                "button": "Токены",
                "name": "Название",
                "prefix": "Префикс",
                "empty": "Токенов пока нет",
                "notFound": "Токены не найдены"
            },
            "create": {
                "trigger": "Создать токен",
                "title": "Создание токена",
                "success": "Токен был успешно создан",
                "error": "Произошла ошибка при создании токена"
            },
            "delete": {
                "title": "Удаление токена",
                "success": "Токен был удален"
            },
            "clipboard": {
                "button": "Копировать в буфер обмена",
                "hint": "Нажмите, чтобы скопировать в буфер обмена",
                "success": "Токен скопирован в буфер обмена!"
            }
        },
        "authors": {
            "noData": "Авторов пока нет",
            "manager": {
                "add": "Добавить автора"
            }
        },
        "notifications": {
            "page": {
                "title": "Уведомления",
                "trigger": "Смотреть старые уведомления"
            },
            "clearAll": "Очистить все",
            "noData": "Новых уведомлений нет"
        },
        "stylesheet": {
            "menuItem": "Правила произношения",
            "title": "Правила произношения",
            "noData": "Пока нет правил",
            "noResults": "Правила не найдены",
            "backButton": "Вернуться к клиенту",
            "results": {
                "id": "ID",
                "target": "Слово / Имя / Фраза",
                "explanation": "Правило произношения / Объяснение"
            },
            "edit": {
                "order": "Заказ"
            },
            "create": {
                "trigger": "Создать правило",
                "title": "Создание правила"
            },
            "delete": {
                "title": "Удаление правила",
                "content": "Выбранное правило будет удалено. Хотите продолжить?",
                "success": "Правило удалено"
            }
        },
        "statistic": {
            "title": "Статистика",
            "menuItem": "Статистика",
            "noData": "Статистики пока нет",
            "noResults": "Статистика не найдена"
        },
        "transitions": {
            "title": "Переходы",
            "menuItem": "Переходы",
            "backButton": "Назад к таблице переходов",
            "noData": "Пока нет переходов",
            "noResults": "Переходы не найдены",
            "results": {
                "source": "Источник",
                "dest": "Цель"
            },
            "graph": {
                "title": "График переходов",
                "create": {
                    "trigger": "Создать график"
                }
            }
        },
        "invites": {
            "title": "Приглашения",
            "menuItem": "Приглашения",
            "results": {
                "noData": "Приглашений пока нет"
            },
            "delete": {
                "title": "Удаление приглашения",
                "content": "Выбранное приглашение будет удалено. Вы хотите продолжить?",
                "success": "Приглашение было удалено"
            },
            "inviteLink": {
                "trigger": "Копировать ссылку",
                "success": "Ссылка скопирована!"
            }
        }
    },
    "backgroundAudio": {
        "title": "Фоновое аудио",
        "form": {
            "label": "Название",
            "filePlaceholder": "Нажмите, чтобы выбрать аудио файл"
        },
        "add": {
            "trigger": "Загрузить файл",
            "title": "Добавление фонового аудио",
            "success": "Аудио файл добавлен"
        },
        "edit": {
            "trigger": "Изменить",
            "title": "Изменение фонового аудио",
            "success": "Фоновое аудио сохранено"
        },
        "delete": {
            "trigger": "Удалить",
            "title": "Удаление фонового аудио",
            "content": "Вы хотите удалить это фоновое аудио?",
            "success": "Фоновое аудио удалено"
        }
    },
    "bookparts": {
        "loading": "Пожалуйста подождите. Предложения загружаются...",
        "noData": "Пока нет предложений",
        "partTitle": "Предложение"
    },
    "audioEditor": {
        "title": "Редактирование аудио",
        "tips": {
            "idle": [
                "Нажмите пробел, чтобы воспроизвести или остановить",
                "Нажмите ПКМ, чтобы воспроизвести с выбранного времени",
                "Нажмите ЛКМ чтобы выбрать фрагмент для редактирования"
            ],
            "creating": "Нажмите еще раз, чтобы выбрать конец фрагмента",
            "completed": "Отрегулируйте время фрагмента, которое вы хотите отредактировать",
            "reading": "Фрагмент {start}s : {end}s",
            "cutted": "@:audioEditor.tips.reading"
        },
        "actions": {
            "selectSegment": "Выбрать фрагмент",
            "deleteSegment": "Удалить фрагмент",
            "cutSegment": "Вырезать фрагмент",
            "uncutSegment": "Отменить"
        }
    },
    "booksBuilds": {
        "title": "Скачать",
        "edit": {
            "builderLabel": "Экспорт:",
            "providerLabel": "Провайдер:",
            "typeLabel": "Тип:",
            "speedLabel": "Скорость:",
            "optionsLabel": "Опции:",
            "optionsList": {
                "fullText": "Весь текст",
                "excludeTitle": "Без заголовка",
                "excludeAuthor": "Без имени автора",
                "excludeAuthorAndTitle": "Без имени автора и заголовка"
            },
            "submitButton": "Создать файлы"
        },
        "list": {
            "title": "Сборки",
            "noDataText": "Пока сборок нет"
        },
        "error": {
            "invalid": "Обязательные поля не заполнены"
        },
        "tips": {
            "trigger": "Менеджер сборок",
            "checking": "Проверяем готовность книги к экспорту",
            "repairing": "Подготавливаемся к экспорту",
            "building": "Идет сборка...",
            "completed": "Сборка завершена"
        },
        "emptyParts": {
            "title": "Ошибки озвучивания",
            "description": "Некоторые предложения в аудиокниге были озвучены неправильно.",
            "actions": {
                "correct": "Исправить ошибки",
                "repair": "Собрать с ошибками"
            }
        }
    },
    "stylesheet": {
        "menuItem": "Правила произношения",
        "title": "Правила произношения",
        "noData": "Пока нет правил",
        "results": {
            "word": "Слово / Имя / Фраза",
            "explanation": "Правило произношения / Объяснение"
        },
        "resultsShort": {
            "word": "Фраза: ",
            "explanation": "Объяснение: "
        }
    },
    "comment": {
        "title": "Комментарии",
        "placeholder": "Комментарий"
    }
}
